const isValidPolygon = (positions) =>
  Array.isArray(positions) &&
  positions.length >= 3 &&
  positions.every(
    (pos) =>
      pos &&
      Number.isFinite(Number(pos.latitude)) &&
      Number.isFinite(Number(pos.longitude))
  );

const toPositions = (positions) =>
  positions.map((pos) => ({
    latitude: Number(pos.latitude),
    longitude: Number(pos.longitude),
  }));

/**
 * Normalized clock-in geofence areas for a project.
 * Prefers the new `proximityToClockInAreas` [{id, positions}] field and
 * falls back to the legacy single `proximityToClockInArea` polygon,
 * returned as one area with a deterministic derived id.
 * Always returns [{ id, positions }] (possibly empty).
 */
export const getProjectClockInAreas = (project) => {
  if (!project) return [];

  if (Array.isArray(project.proximityToClockInAreas)) {
    const areas = project.proximityToClockInAreas
      .filter((area) => area && isValidPolygon(area.positions))
      .map((area, index) => ({
        id: area.id || `${project.id || 'project'}-area-${index}`,
        positions: toPositions(area.positions),
      }));
    if (areas.length) return areas;
  }

  if (isValidPolygon(project.proximityToClockInArea)) {
    return [
      {
        id: `${project.id || 'project'}-legacy-area`,
        positions: toPositions(project.proximityToClockInArea),
      },
    ];
  }

  return [];
};
